import { render, staticRenderFns } from "./BdoMerchantA.vue?vue&type=template&id=cb469054&scoped=true"
import script from "./BdoMerchantA.vue?vue&type=script&lang=js"
export * from "./BdoMerchantA.vue?vue&type=script&lang=js"
import style0 from "./BdoMerchantA.vue?vue&type=style&index=0&id=cb469054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb469054",
  null
  
)

export default component.exports